import { useEffect } from "react"
import { preLoaderAnim } from "../animations"

const PreLoader = () => {

  useEffect(()=> {
    preLoaderAnim()
  })

  return (
    <div className="preloader">
      <div className="texts-container">
        <span>Dévéloppeur,</span>
        <span>Animateur,</span>
        <span>Formateur.</span>
      </div>
    </div>
  )
}

export default PreLoader;